module.exports = __webpack_public_path__ + "img/9.cf24755e.jpg";